export default __webpack_public_path__ + "static/media/bg_hk.4f77fc68.png";